<template>

    <b-row>
      <b-col class="pr-0" v-bind:class="{'d-none d-md-block': !$store.state.open_room_id}">
        <div class="card chat_body" style="margin-bottom:0px;overflow-x:hidden;height:90vh !important;" ref="dialogWindow">
          <chat-messages v-if="$store.state.open_room_id" :room_id="$store.state.open_room_id" ></chat-messages>
          <div id="open_dialog_window" v-show="!$store.state.open_room_id">
            <h3 align="center" class="py-2" style="valign:middle">{{ $t('chatlab') }}</h3>
            <friends class="m-3"></friends>
          </div>

          <div class="card-body " id="message_panel" v-show="$store.state.open_room_id" >
            <message @sendByEnter="sendByEnter" ref="newMessageArea"></message>
            <br>
              Чтобы перейти на новую строку нажмите shift + enter
              <div  class="pull-right">
                <b-form inline>
                  <b-form-checkbox v-model="send_by_enter" class="mb-2 mr-sm-2 mb-sm-0">{{ $t('Sendent') }}</b-form-checkbox>
                  <b-button variant="primary" v-on:click="sendMessage()">{{ $t('Send') }}</b-button>
                </b-form>
                 
              </div>
              
          </div>

        </div>
      </b-col>
      <b-col cols="auto" v-bind:class="{'d-none d-md-block': $store.state.open_room_id}">
        <div class="card users">
          <chat-rooms v-on:open-room="$store.state.open_room_id = $event"></chat-rooms>
        </div>
      </b-col>
    </b-row>

</template>
<i18n>
  {
  "en": {
  "chatlab": "Select a user to start a conversation", 
  "Sendent": "Send when you press enter", 
  "Send": "Send"

  },
  "ru": {
  "chatlab": "Выберите пользователя чтобы начать диалог",
  "Sendent": "Отправлять при нажатии enter", 
  "Send": "Отправить"

  }
  }
</i18n>
<script>
  import message from '../layout/message'
  import ChatRooms from './ChatRooms'
  import ChatMessages from './ChatMessages'
  import friends from './main'
  export default {
    name: 'chat',
    components: {
      message,
      ChatRooms,
      ChatMessages,
      friends
    },
    data() {
      return {
        send_by_enter: true
      }
    },
    methods: {
      sendByEnter() {
        if (this.send_by_enter == true) {
          this.sendMessage()
        }
      },
      sendMessage() {
        var text = this.$refs.newMessageArea.text
        if (text) {
          this.$http.post('chat/message?room_id=' + this.$store.state.open_room_id, {
            'message': text // Axios
          })
                  .then(response => {
                    // JSON responses are automatically parsed.
                    // this.errors = response.data.errors
                    this.$refs.newMessageArea.text = ''
                  }).catch(e => {
            alert(e.response.data)
          })
        } else {
          alert('Напишите сообщение')
        }
      },
      sendMessage1() {
        var text = this.$refs.newMessageArea.text
        if (text) {
          this.$socket.send(JSON.stringify({'action': 'chat', 'target': this.$store.state.open_room_id, 'message': text}))
          this.$refs.newMessageArea.text = ''
        } else {
          alert('Напишите сообщение')
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .users {
        
        margin-bottom:0px; 
        overflow-x:hidden;
        
    }
  .box {
    margin-bottom: 0px; 
  }
  @media (max-width: 767px) {
     .users {
        width:100%; 
        height:100%;
    }
    .card{
        position:fixed
    }
  }
  @media (min-width: 768px) {
    .users {
        width:250px;
        height:90vh !important;
    }
  }


  @media (min-width: 768px) and (max-width: 991px) {
    .chat_body{
      max-width: calc(100vw - 353px);
    }

  }
  @media (min-width: 992px) {
    .chat_body{
      max-width: calc(100vw - 527px);
    }
  }
</style>
